import components from "./components.js";
import pages from "./pages/index.js";
import wlps from "./wlps.js";

export default {
  apply: "Aplicar",
  asOf: (ctx) => `a partir de ${ctx.named("date")}`,
  cancel: "Cancelar",
  contactUs: "Contáctenos",
  edit: "Editar",
  error: "Error",
  from: "Desde",
  ok: "Aceptar",
  loading: "Cargando...",
  logIn: "Iniciar sesión",
  logOut: "Cerrar sesión",
  no: "No",
  others: "Otros",
  register: "Registrarse",
  save: "Guardar",
  saving: "Guardando...",
  serverError:
    "Ocurrió un error en nuestro servidor. Se ha enviado un informe a nuestro equipo y lo solucionaremos lo antes posible. No dude en contactarnos si el problema persiste.",
  success: "Éxito",
  to: "A",
  warning: "Advertencia",
  yes: "Sí",
  investorProfileTypes: {
    institutional: "Inversor institucional",
    professional: "Inversor profesional",
    retail: "Inversor minorista",
  },
  layouts: {
    main: {
      admin: {
        listUsers: "Lista de usuarios",
        platformSettings: "Configuración de la plataforma",
        products: "Productos",
        sectionName: "Admin",
        holdingDataAdjustments: {
          name: "Ajustes de datos de tenencia",
          categorise: {
            name: "Categorizar",
          },
          translate: {
            name: "Traducir",
          },
          override: {
            name: "Anular",
          },
        },
        operations: {
          name: "Operaciones",
          bulkPriceDataUpdate: {
            name: "Actualizar datos de precios",
          },
          generateReports: {
            name: "Generar informes",
          },
          bulkComponentsUpdate: {
            name: "Importar componentes genéricos",
          },
          exports: {
            name: "Exportaciones",
          },
        },
      },
      help: {
        contact: "Contacto",
        faq: "Preguntas frecuentes",
        knowledgeBase: "Base de conocimientos",
        sectionName: "Ayuda",
      },
      investmentProposal: {
        sectionName: "Propuesta de inversión",
        reportGenerationSubSectionName: "Generación de informes",
        weightOptimizationSubSectionName: "Optimización de pesos",
      },
      products: {
        analysis: "Análisis",
        documents: "Documentos",
        factsheet: "Factsheet",
        overview: "Resumen",
        sectionName: "Productos",
        useCase: "Caso de uso",
      },
    },
    fullPage: {
      backHome: "Volver a inicio",
    },
    navbar: {
      openInVue3: "Cambiar a la nueva versión",
    },
    profileDropDown: {
      settings: "Configuración",
      dialog: {
        adminAsRegularOnMobile: {
          text: "Las funciones administrativas no se pueden acceder en dispositivos móviles. Para disfrutar plenamente de la plataforma, utilice una computadora de escritorio. Las funciones de administración deshabilitadas incluyen (pero no se limitan a): editar elementos en el Resumen, editar un informe, cargar o eliminar documentos y acceder a la sección de administración.",
          title: "Se requiere una computadora de escritorio para las funciones de administración",
        },
      },
    },
    theFooter: {
      allRightReserved: "Todos los derechos reservados",
      copyright: "Derechos de autor",
      ombudsman: "Defensor del pueblo",
      privacyPolicy: "Política de privacidad",
      termsOfUse: "Términos de uso",
    },
    verticalNavMenu: {
      closeMenuTextWhenEmbedded: "Cerrar",
      errorLoading: "Error al cargar el menú",
      openMenuTextWhenEmbedded: "Mostrar todos los fondos",
    },
    verticalNavMenuGroup: {
      search: "Buscar",
      showMore: "Mostrar más",
    },
  },
  perfStats: {
    alpha: "Alfa",
    annualizedReturn: "Retorno anualizado",
    annualizedVolatility: "Volatilidad anualizada",
    annualizedVolatilityDaily: "Volatilidad anualizada (diaria)",
    averageMonthlyReturns: "Retornos mensuales promedio",
    averageNegativeMonthlyReturns: "Retornos mensuales negativos promedio",
    averagePositiveMonthlyReturns: "Retornos mensuales positivos promedio",
    beta: "Beta",
    calmarRatio: "Ratio de Calmar",
    painRatio: "Ratio de Dolor",
    painIndex: "Índice de dolor",
    correlation: "Correlación",
    cumulativeReturn: "Retorno acumulado",
    informationRatio: "Ratio de información residual",
    activeInformationRatio: "Ratio de información activa",
    kurtosis: "Curtosis",
    m2RiskAdjustedPerfMonthly: "Medida M2",
    maxDaysUnderwater: "Máximo de días bajo el agua",
    maxMonthsUnderwater: "Máximo de meses bajo el agua",
    maxConsecutiveNegativeMonthlyReturns: "Máximo de retornos mensuales negativos consecutivos",
    maxConsecutivePositiveMonthlyReturns: "Máximo de retornos mensuales positivos consecutivos",
    maxNegativeMonthlyReturn: "Máximo retorno mensual negativo",
    maxPositiveMonthlyReturn: "Máximo retorno mensual positivo",
    maximumDrawdown: "Caída máxima",
    maximum: "Máximo",
    minimum: "Mínimo",
    omegaRatio: "Ratio de Omega",
    ratioOfNegativeMonthlyReturns: "Relación de retornos mensuales negativos",
    ratioOfPositiveMonthlyReturns: "Relación de retornos mensuales positivos",
    returnToVolatilityRatio: "Relación de retorno a volatilidad",
    sharpeRatio: "Ratio de Sharpe",
    skewness: "Asimetría",
    sortinoRatio: "Ratio de Sortino",
    trackingError: "Error de seguimiento",
    treynorRatio: "Ratio de Treynor",
    valueAtRiskOnePercentOneMonth: "Valor en riesgo (VaR) 1% en 1 mes",
    valueAtRiskFivePercentOneMonth: "Valor en riesgo (VaR) 5% en 1 mes",
    valueAtRiskOnePercentTwoWeeks: "Valor en riesgo (VaR) 1% en 2 semanas",
    valueAtRiskFivePercentTwoWeeks: "Valor en riesgo (VaR) 5% en 2 semanas",
    valueAtRiskOnePercentOneDay: "Valor en riesgo (VaR) 1% en 1 día",
    valueAtRiskFivePercentOneDay: "Valor en riesgo (VaR) 5% en 1 día",
  },
  validations: {
    afterDate: (ctx) =>
      `La fecha debe ser posterior a ${ctx.named("minDate")}${ctx.named("nDaysApart") == 0 ? " (incluida)" : " con al menos " + ctx.named("nDaysApart") + " días de diferencia"}`,
    beforeDate: (ctx) =>
      `La fecha debe ser anterior a ${ctx.named("maxDate")}${ctx.named("nDaysApart") == 0 ? " (incluida)" : " con al menos " + ctx.named("nDaysApart") + " días de diferencia"}`,
    confirmed: "El campo no coincide con el anterior.",
    dateFormat: "La fecha debe estar en el formato AAAA-MM-DD.",
    email: "El correo electrónico no es válido.",
    maxFileSize: (ctx) =>
      `El archivo es más grande que el tamaño máximo autorizado (${ctx.named(
        "maxSizeMegabytes"
      )} MB).`,
    maxChar: (ctx) => `El campo no puede tener más de ${ctx.named("length")} caracteres.`,
    minChar: (ctx) => `El campo necesita al menos ${ctx.named("length")} caracteres.`,
    minValue: (ctx) => `El valor debe ser mayor o igual a ${ctx.named("min")}.`,
    phoneNumber: "Este campo no es un número de teléfono válido.",
    required: "Este campo es requerido.",
    roleFormat: 'El nombre del rol no puede contener el carácter ":".',
    forbiddenRoleName: "Este nombre de rol está reservado.",
    sum: (ctx) =>
      `La suma esperada es ${ctx.named("expectedValue")} (actual: ${ctx.named("currentValue")}).`,
  },
  wlps,
  pages,
  components,
};
